var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var animations = require('../libs/animations');
var loginPasswordInput = require('./components/loginPasswordInput');

function nonJsonErrors(xhr) {
  return xhr.status > 200 ? JSON.stringify(xhr.responseText) : xhr.responseText;
}

function cloudLoginErrorFromLocation() {
  if (typeof window === 'undefined' || !window.location) return false;
  return new URLSearchParams(window.location.search).get('cloudLoginError') || false;
}

var login = {};

login.oninit = function (vnode) {
  var ctrl = vnode.state;
  ctrl.email = prop(null);
  ctrl.password = prop(null);
  ctrl.message = prop(null);
  ctrl.messageClass = prop('success');
  ctrl.succeeded = prop(false);
  ctrl.step = 'emailStep';
  ctrl.expiredPassword = prop(false);
  ctrl.cloudLoginEnabled = typeof cloudLoginEnabled === 'boolean' && cloudLoginEnabled;

  var loginError = (typeof azureLoginError === 'string' && azureLoginError) || cloudLoginErrorFromLocation();
  if (loginError) {
    ctrl.message(loginError);
    ctrl.messageClass('bg-red');
  }

  ctrl.submitEmail = function (event) {
    event.preventDefault();
    if (!ctrl.email()) {
      ctrl.message('Please enter your email address');
      ctrl.messageClass('bg-gray');
      return;
    }

    ctrl.message(false);
    return loaders.requestWithLoader({
      loader: 'submit',
      url: '/sendtoken',
      method: 'POST',
      extract: nonJsonErrors,
      body: { user: ctrl.email() }
    })
    .then(function (response) {
      response = JSON.parse(response);
      if (response.status === 'ok') {
        ctrl.message('Authentication email has been sent');
        ctrl.messageClass('bg-blue');
        ctrl.succeeded(true);
      } else {
        ctrl.message('Invalid Email Address');
        ctrl.messageClass('bg-red');
      }
    })
    .catch(function () {
      ctrl.message('The server cannot be reached');
      ctrl.messageClass('bg-red');
      ctrl.succeeded(false);
    });
  };

  ctrl.submitPassword = function (event) {
    event.preventDefault();
    ctrl.message(false);
    if (!ctrl.email()) {
      ctrl.message('Please enter your email address');
      ctrl.messageClass('bg-gray');
      return;
    }

    return loaders.requestWithLoader({
      loader: 'submit',
      url: '/login',
      method: 'POST',
      responseType: 'json',
      body: {
        email: ctrl.email(),
        password: ctrl.password()
      }
    })
    .then(function (response) {
      if (response.status === 'ok') {
        ctrl.message('Authentication Successful');
        ctrl.messageClass('bg-blue');
        window.location.href = '/';
      }
    })
    .catch(function (error) {
      ctrl.message(error && error.error ? error.error : 'Invalid Login');
      if (error && error.error === 'Password expired. Please login with Email Link') ctrl.expiredPassword(true);
      ctrl.messageClass('bg-red');
    });
  };
};

login.view = function (vnode) {
  var ctrl = vnode.state;
  if (ctrl.cloudLoginEnabled) {
    return m('div.login-container', [
      m('h3', 'Sign in to Nimrod'),
      ctrl.message() ? m('div.bg-red', ctrl.message()) : '',
      m('p', 'Use your invited Microsoft Entra identity.'),
      m('button', {
        type: 'button',
        class: 'btn-login',
        onclick: function () { window.location.assign('/auth/cloud/login'); }
      }, 'Sign in with Nimrod Cloud')
    ]);
  }

  function emailStep() {
    return m('div', {oncreate: animations.fadesIn}, [
      m('input.mb2.pa2', {
        name: 'email',
        type: 'email',
        class: 'login-input',
        placeholder: 'EMAIL',
        oninput: function (event) { ctrl.email(event.target.value); },
        value: ctrl.email()
      }),
      m('button', {type: 'submit', class: 'btn-login', onclick: ctrl.submitEmail}, 'Send Email Token'),
      m('h5.tc.moon-gray.mv1.pb1.bb', 'OR'),
      m('button', {
        type: 'button',
        class: 'btn-login',
        onclick: function () { ctrl.step = 'passwordStep'; }
      }, 'Use Password')
    ]);
  }

  function passwordStep() {
    return m('form', {oncreate: animations.fadesIn}, [
      m('input.mb2.pa2', {
        name: 'email',
        type: 'email',
        class: 'login-input',
        placeholder: 'EMAIL',
        oninput: function (event) { ctrl.email(event.target.value); },
        value: ctrl.email()
      }),
      m(loginPasswordInput, {password: ctrl.password}),
      m('button', {type: 'submit', class: 'btn-login', onclick: ctrl.submitPassword}, 'Login'),
      m('h4.tc.moon-gray.pb1.bb', 'Or'),
      m('button', {
        type: 'button',
        class: 'btn-login',
        onclick: function () { ctrl.step = 'emailStep'; }
      }, 'Use Email Link')
    ]);
  }

  function emailOnlyStep() {
    return m('div', {oncreate: animations.fadesIn}, [
      m('input.mb2.pa2', {
        name: 'email',
        type: 'email',
        class: 'login-input',
        placeholder: 'EMAIL',
        oninput: function (event) { ctrl.email(event.target.value); },
        value: ctrl.email()
      }),
      m('button', {type: 'submit', class: 'btn-login', onclick: ctrl.submitEmail}, 'Send Email Token')
    ]);
  }

  return m('div.container', [
    m('div.login', [
      m('div.mb2.pa2.tc', {
        class: ctrl.message() ? ctrl.messageClass() : '',
        oncreate: animations.fadesIn
      }, ctrl.message() ? m('span', ctrl.message()) : ''),
      m('form', [
        loaders.submit.show() ? m('div', [
          m('input.mb2', {name: 'email', type: 'email', class: 'login-input', placeholder: 'EMAIL', value: ctrl.email()}),
          m('button', {type: 'button', class: 'btn-login'}, [m('img', {src: '/images/loading-bars.svg'})])
        ]) : (ctrl.succeeded() ? [] : (ctrl.expiredPassword() ? emailOnlyStep() : (ctrl.step === 'emailStep' ? emailStep() : passwordStep())))
      ])
    ])
  ]);
};

module.exports = login;
